const INVALID_SEGMENT = /[/\\]/;

/** Validates a workspace-relative path without resolving filesystem handles. */
export function normalizeRelativePath(segments: readonly string[]): readonly string[] {
  return segments.map((segment) => {
    const normalized = segment.normalize("NFC").trim();

    if (
      normalized.length === 0 ||
      normalized === "." ||
      normalized === ".." ||
      INVALID_SEGMENT.test(normalized) ||
      normalized.includes("\0")
    ) {
      throw new Error(`Invalid workspace path segment: ${JSON.stringify(segment)}.`);
    }

    return normalized;
  });
}

/** Converts a validated relative path to its portable slash-separated form. */
export function formatStoredPath(segments: readonly string[]): string {
  return normalizeRelativePath(segments).join("/");
}

/** Parses a portable path while rejecting absolute and traversing forms. */
export function parseStoredPath(path: string): readonly string[] {
  if (path.startsWith("/") || path.endsWith("/") || path.includes("//")) {
    throw new Error("Workspace paths must be normalized and relative.");
  }

  return normalizeRelativePath(path.split("/"));
}

/** Confirms that a persisted asset path remains inside the board's asset directory. */
export function parseAssetPath(path: string): readonly ["assets", string] {
  const segments = parseStoredPath(path);

  if (segments.length !== 2 || segments[0] !== "assets" || segments[1] === undefined) {
    throw new Error("Board assets must be direct children of the assets directory.");
  }

  return ["assets", segments[1]];
}
